module.exports = __webpack_public_path__ + "static/media/search.e9612850.png";